<form *ngIf="!token" [formGroup]="loginForm" class="main-panel__form">
  <div
    class="text-center text-md-center mt-md-0 img-login px-4 pb-3 px-lg-2 px-md-5"
  >
    <img src="assets/img/Digital-Ware.png" alt="Logo" />
  </div>
  <div class="form__group px-3">
    <p>
      <small
        >Escribe el correo electrónico asociado a tu cuenta y te ayudaremos a
        recuperala</small
      >
    </p>
  </div>
  <div class="form__group px-3">
    <label for="" class="form__label">Correo electrónico</label>
    <input
      formControlName="usuario"
      id="usuario"
      type="email"
      name=""
      class="form__input"
      [ngClass]="{
        'alert alert-danger':
          loginForm.get('usuario')?.touched && loginForm.get('usuario')?.invalid
      }"
      placeholder="Nombre de usuario"
      value=""
      [class.is-invalid]="usuario?.invalid && usuario?.touched"
      required
    />
    <div *ngIf="(usuario?.invalid && usuario?.touched) || usuario?.dirty">
      <small *ngIf="usuario?.errors?.required" class="invalid-feedback"
        >Por favor, ingrese su correo</small
      >
    </div>
  </div>
  <div class="text--center px-3 my-4">
    <button
      [disabled]="loginForm.invalid"
      class="form__button"
      (click)="remember('user')"
    >
      Recuperar
    </button>
  </div>
  <div class="text--center px-3 my-4 w-100">
    <button
      class="btn btn-outline-dark secondaryButton w-100"
      type="button"
      (click)="back()"
    >
      Volver
    </button>
  </div>
</form>

<form *ngIf="token" [formGroup]="resetPasword" class="main-panel__form">
  <div
    class="text-center text-md-center mt-md-0 img-login px-4 pb-3 px-lg-2 px-md-5"
  >
    <img src="assets/img/Digital-Ware.png" alt="Logo" />
  </div>

  <div class="form__group px-3">
    <label for="" class="form__label">Ingrese nueva contraseña</label>
    <div class="d-flex">
      <!-- <input
        formControlName="passNew"
        id="passNew"
        [type]="showPassword ? 'text' : 'password'"
        min={{par_nmin}} 
        max={{par_nmax}} 
        name=""
        class="form__input"
       
        placeholder="Contraseña"
        value=""
   
        required
      /> -->

      <input
      formControlName="passNew"
      id="passNew"
      [type]="showPassword ? 'text' : 'password'"
      class="form__input"
      placeholder="Contraseña"
      required
      [attr.minlength]="par_nmin"
      [attr.maxlength]="par_nmax"
    />
      <!-- <i id="questionPass" class="fa-solid fa-question centerI"></i>  -->
      <button
      type="button" 
      class="btn position-absolute end-0 me-2 bg-transparent border-0"
      (click)="togglePasswordVisibility()"
      tabindex="-1"
    >
    <i
    class="fa-solid"
    style="    position: absolute;
    /* right: 16%; */
    left: 216px;
    /* top: 40px; */
    font-size: 1.2rem;
    cursor: pointer;
    color: #202945;
    font-family: 'Font Awesome 6 Free' !important;"
    [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
  ></i>
    </button>
    </div>
    <!-- <div *ngIf="(passNew?.invalid && passNew?.touched) || passNew?.dirty">
      <div *ngIf="passNew?.errors">Por favor digite una contraseña válida</div>
    </div> -->
  </div>
  <div class="form__group px-3">
    <label for="" class="form__label">Confirma la contraseña</label>
    <input
      formControlName="passRepeat"
      id="passRepeat"
      type="password"
      name=""
      class="form__input"
      [ngClass]="{
        'alert alert-danger':
          loginForm.get('passRepeat')?.touched &&
          loginForm.get('passRepeat')?.invalid
      }"
      placeholder="Confirmar contraseña"
      value=""
      [class.is-invalid]="passRepeat?.invalid && passRepeat?.touched"
      required
    />
    <div
      *ngIf="(passRepeat?.invalid && passRepeat?.touched) || passRepeat?.dirty"
    >
      <small *ngIf="passRepeat?.errors?.required" class="invalid-feedback"
        >* Por favor, ingresa una contraseña</small
      >
      <small
        *ngIf="passRepeat?.value != passNew?.value"
        class="invalid-feedback"
        >* Las contraseñas no son iguales</small
      >
    </div>


    <div *ngIf="(passNew?.invalid && (passNew?.touched || passNew?.dirty))">
      <small *ngIf="passNew?.errors?.required" class="invalid-feedback">
        * Por favor, ingresa una contraseña
      </small>
      <small *ngIf="passNew?.errors?.minlength" class="invalid-feedback">
        * La contraseña debe tener al menos {{ par_nmin }} caracteres
      </small>
      <small *ngIf="passNew?.errors?.maxlength" class="invalid-feedback">
        * La contraseña no debe superar los {{ par_nmax }} caracteres
      </small>
    </div>

  </div>
  <div class="text--center px-3 my-4">
    <button
      [disabled]="resetPasword.invalid || passRepeat?.value != passNew?.value"
      class="form__button"
      (click)="resetPassword()"
    >
      Aceptar
    </button>
  </div>
  <div class="text--center px-3 my-4 w-100">
    <button
      class="btn btn-outline-dark secondaryButton w-100"
      type="button"
      (click)="back()"
    >
      Cancelar recuperación
    </button>
  </div>
</form>




<!-- <dx-tooltip
  target="#questionPass"
  showEvent="mouseenter"
  hideEvent="mouseleave"
  position="right"
>
<div *ngIf="resetPasword.get('passNew')?.touched && resetPasword.get('passNew')?.invalid" class="text-danger mt-1">
  <div *ngIf="resetPasword.get('passNew')?.errors?.['required']">
    La contraseña es obligatoria.
  </div>
  <div *ngIf="resetPasword.get('passNew')?.errors?.['minlength']">
    La contraseña debe tener al menos {{ par_nmin }} caracteres.
  </div>
  <div *ngIf="resetPasword.get('passNew')?.errors?.['maxlength']">
    La contraseña no debe superar los {{ par_nmax }} caracteres.
  </div>
</div>
</dx-tooltip> -->
